export default {"src":"/_next/static/media/onions.a9a4dd38.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};